<div class="row justify-content-center alert-banner">
  <div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-dismissable col-md-8">
    <span class="fa {{ iconSelection(alert) }} icon"></span>
    <span class="message"> {{ alert.message }}</span>
    <a class="close" (click)="removeAlert(alert)">&times;</a>
  </div>
</div>
